import { CreateAbstractPromptRequest } from '@pushly/models/lib/structs/prompts/styles/create-abstract-prompt-request'
import { UpdateAbstractPromptRequest } from '@pushly/models/lib/structs/prompts/styles/update-abstract-prompt-request'
import { CreatePromptGroupRequest } from '@pushly/models/lib/structs/prompts/create-prompt-group-request'
import { UpdatePromptGroupRequest } from '@pushly/models/lib/structs/prompts/update-prompt-group-request'

export enum VisitorCondition {
    EVERYONE = 0,
    TIME_ON_PAGE = 1,
    SESSION_PAGE_VIEWS = 2,
    SCROLL_DEPTH = 3,
    SESSION_TIME_ON_SITE = 8,
}

export type PromptEditorGroup = CreatePromptGroupRequest | UpdatePromptGroupRequest
export type PromptEditorTreatment = CreateAbstractPromptRequest | UpdateAbstractPromptRequest
